export class SelectLanguageConstants {
    static readonly LANGUAGE_HEADING = $localize`:@@select-lang.heading.language:LANGUAGE`;
    static readonly LANGUAGE = $localize`:@@select-lang.heading.name:Language`;
    static readonly HELP = $localize`:@@select-lang.help:Help`;
    static readonly CANCEL = $localize`:@@select-lang.cancel:Cancel`;
    static readonly SELECT_LANGUAGE = $localize`:@@select-lang.select-lang:Select Language`;
    static readonly LOGIN_DEFAULT = $localize`:@@select-lang.login:Login`;
    static readonly CREATE_ACCOUNT = 'createAccount';
    static readonly LANGUAGE_SUB_HEADING_DESC = $localize`:@@select-lang.select-text:Select which language you want to use for IPOS Central. You can always change this later by selecting ”Language” in the header.`;
    static readonly SEARCH_LANGUAGE = $localize`:@@select-lang.search-lang:Search Language...`;
    static readonly ALL_LANGUAGES_TEXT = $localize`:@@select-lang.all-lang:All Languages`;
}
